import { IStore } from 'store/configureStore';

export const selectRejectOfferIsLoading = (state: IStore) => state.modules.offerLetter.rejectOfferLetter.isLoading;
